import { Box } from '@mui/material';
import React from 'react';
import DecorativePattern from 'src/icons/DecorativePattern';

interface LoginContainerProps {
  children?: React.ReactNode;
}
const LoginContainer = ({ children }: LoginContainerProps) => {
  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        py: '1rem',
      }}
    >
      {children && React.Children.map(children, (child) => child)}
      <DecorativePattern
        style={{
          position: 'absolute',
          bottom: '0',
          left: '0',
          aspectRatio: '1/1',
          width: 'calc(20% + 100px)',
          height: 'auto',
        }}
      />
      <DecorativePattern
        style={{
          position: 'absolute',
          top: '0',
          right: '0',
          transform: 'rotate(180deg)',
          aspectRatio: '1/1',
          width: 'calc(20% + 30px)',
          height: 'auto',
        }}
      />
    </Box>
  );
};

export default LoginContainer;
